import Vue from 'vue'
import { BAlert } from 'bootstrap-vue'
import BannerSortOrder from './banner_sort_order/BannerSortOrder'
import { i18n } from './gifts/config/translations.js'
import axios from 'axios'

export default function bannerSortOrder () {
  const appContainer = document.getElementById('vue-banner-sort-order')

  // configure axios
  const token = document
    .querySelector('meta[name="csrf-token"]')
    .getAttribute('content')

  axios.defaults.headers.common['X-CSRF-Token'] = token

  if (appContainer) {
    i18n.setLocaleMessage('default', {
      submit: appContainer.dataset.submit,
      banner_ordering_successful: appContainer.dataset.bannerOrderingSuccessful
    })

    const el = appContainer.appendChild(document.createElement('app'))
    Vue.component('BAlert', BAlert)
    Vue.directive('b-alert', BAlert)
    /* eslint-disable no-unused-vars */
    const app = new Vue({
      i18n,
      el,
      render: h => h(BannerSortOrder)
    })
    /* eslint-enable no-unused-vars */
  }
}
